<template>
  <v-card flat>
    <v-card-title>
      <v-btn
        v-status="'role_create'"
        :to="{ name: 'permission.create' }"
        class="btn-add-with-text"
      >
        <v-icon>mdi-plus</v-icon>
        افزودن پرمیشن
      </v-btn>
      <!--                <v-spacer/>-->
      <!--                {{ $t($route.meta.title) }}-->
      <!--                <v-spacer/>-->
      <!--                <v-btn :loading="loading" @click="reload"-->
      <!--                       class="btn-update">-->
      <!--                  <v-icon>mdi-refresh</v-icon>-->
      <!--                  به روزرسانی-->
      <!--                </v-btn>-->
    </v-card-title>

    <v-divider />

    <v-row no-gutters>
      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-select
          v-model="tableProps.length"
          :items="[10, 25, 50, 100, 200, 400]"
          :menu-props="{ offsetY: true }"
          dense
          hide-details
          outlined
          @change="onPerPage"
        />
      </v-col>

      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-text-field
          v-model="tableProps.search"
          append-icon="mdi-magnify"
          clear-icon="mdi-close-circle-outline"
          clearable
          dense
          hide-details
          label="جستجو"
          outlined
          @keydown.enter="reloadTable()"
          @click:append="reloadTable()"
          @click:clear="clearField"
        />
      </v-col>

      <v-col class="pa-2" cols="12">
        <data-table :columns="columns" :data="data" :translate="translates">
          <div slot="filters" />

          <div slot="pagination">
            <pagination
              v-if="data && data.data"
              ref="pagination"
              :data="data"
              @page="onPagination"
            >
              <template v-slot:per-page>
                <v-select
                  v-model="tableProps.length"
                  :items="[10, 25, 50, 100, 400]"
                  :menu-props="{ offsetY: true }"
                  class="ma-2 my-md-0"
                  dense
                  label="تعداد نمایش"
                  outlined
                  @change="onPerPage"
                />
              </template>
            </pagination>
          </div>
        </data-table>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Button from "@/view/pages/Button";
import { SET_BREADCRUMB } from "../../../core/services/store/breadcrumbs.module";
import Pagination from "../pickers/pagination";

export default {
  components: { Pagination },
  data() {
    return {
      loading: false,
      data: {},
      dialog: false,
      item: null,
      url: "permission",
      columns: [
        {
          name: "id",
          label: "شناسه",
          orderable: true,
        },
        {
          label: "نام",
          name: "name",
        },
        {
          label: "نام فارسی",
          name: "name_fa",
        },

        {
          label: "دسته بندی مربوطه",
          name: "category",
          transform: (value, data) => {
            return !value.data.category
              ? '<p class="text-danger">ندارد</p>'
              : value.data.category.name;
          },
        },

        // {
        //   name: 'actions',
        //   label: 'عملیات',
        //   component: Button,
        //   handler: this.actions,
        //   event: 'action',
        //   meta: {
        //     permission_prefix: 'permission_',
        //     buttons: [
        //       {
        //         name: 'edit',
        //         label: 'ویرایش',
        //         icon: 'pencil-alt',
        //         class: 'btn-edit'
        //
        //       },
        //     ]
        //   }
        // }
      ],
      tableProps: {
        page: 1,
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
      },
    };
  },

  mounted() {
    this.getConfigs(this.url);
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
  },

  computed: {
    config() {
      return this.layoutConfig();
    },
  },

  methods: {
    onPagination(e) {
      if (e !== this.page) {
        this.tableProps.page = e;
        this.$nextTick(() => {
          this.getConfigs();
          window.scrollTo({ behavior: "smooth", top: 0, left: 0 });
        });
      }
    },
    onPerPage() {
      this.$refs.pagination.last_emit = 1;
      this.tableProps.page = 1;
      this.$nextTick(() => {
        this.reloadTable();
      });
      window.scrollTo({ behavior: "smooth", top: 0, left: 0 });
    },
    reloadTable(tableProps) {
      this.getConfigs(this.url, tableProps);
    },
    clearField() {
      this.$nextTick(() => {
        this.reloadTable();
      });
    },
    getConfigs(url = this.url, query = this.tableProps) {
      this.loading = true;
      this.requestApiGet(url, query)
        .then((response) => {
          this.data = response.data;
          this.loading = false;
        })
        .catch((error) => {});
    },
    reload() {
      this.getConfigs(this.url, this.tableProps);
    },
    actions(data, type) {
      this[type](data);
    },
    show(data) {
      this.item = data;
      this.dialog = true;
    },
    edit(data) {
      this.$router.push({ name: "permission.edit", params: { id: data.id } });
    },
  },
};
</script>
